/**
 * Filter an availability map down to only the days that fall inside the given
 * window (inclusive, `YYYY-MM-DD` string comparison).
 *
 * The hook accumulates days across every window visited so far; the legend must
 * reflect ONLY the current window. Returns an empty object when there is no
 * window or when no loaded day falls inside it, so the legend shows nothing for
 * a not-yet-loaded window instead of falling back to a previously loaded one.
 *
 * @param {Record<string, Object>} availability  Days indexed by `YYYY-MM-DD`.
 * @param {{ from: string, to: string }|null} window  Inclusive date window.
 * @returns {Record<string, Object>} Subset of `availability` within the window.
 */
const filterAvailabilityToWindow = (availability, window) => {
  if (!window || !availability) return {};
  const { from, to } = window;
  return Object.fromEntries(
    Object.entries(availability).filter(
      ([dateKey]) => dateKey >= from && dateKey <= to,
    ),
  );
};

export default filterAvailabilityToWindow;
